/**
 * Filter product gallery by Color option using image filename prefixes.
 * Supports multiple photos per color (gray.jpg, gray2.png, gray3.png, etc.).
 *
 * Revert: delete this file and remove its script tag + mp-color-media-map render.
 */
(function () {
  'use strict';

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function colorKey(value) {
    var key = handleize(value).replace(/-/g, '');
    return key === 'gray' ? 'grey' : key;
  }

  function normalizeMediaPrefix(prefix) {
    var normalized = String(prefix || '')
      .toLowerCase()
      .trim()
      .replace(/\d+$/, '');

    if (normalized === 'gray') {
      normalized = 'grey';
    }

    return normalized;
  }

  function prefixMatchesColor(mediaPrefix, colorValue) {
    var prefix = normalizeMediaPrefix(mediaPrefix);
    if (!prefix) return false;

    var valueKey = colorKey(colorValue);
    if (prefix === valueKey) return true;

    if (valueKey.length > prefix.length && valueKey.indexOf(prefix) === 0) {
      return false;
    }

    switch (prefix) {
      case 'black':
        return valueKey.indexOf('black') !== -1;
      case 'white':
        return valueKey === 'white' || valueKey.indexOf('solidwhite') !== -1;
      case 'green':
        return valueKey === 'green' || valueKey.indexOf('militarygreen') !== -1;
      case 'grey':
        return (
          valueKey === 'grey' ||
          valueKey === 'gray' ||
          valueKey.indexOf('lightgrey') !== -1 ||
          valueKey.indexOf('lightgray') !== -1
        );
      case 'navy':
        return valueKey === 'navy' || valueKey.indexOf('midnightnavy') !== -1;
      default:
        if (prefix.length >= 3) {
          return valueKey.indexOf(prefix) !== -1;
        }
        return false;
    }
  }

  function readMap(productInfo) {
    var script = productInfo.querySelector('[data-mp-color-media-map]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function readSelectedVariant(productInfo) {
    var script = productInfo.querySelector('[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function loadDeferredSlideImage(slide) {
    if (!slide) return;

    slide.querySelectorAll('img[data-mp-defer-src]').forEach(function (img) {
      if (window.MPDeferredAssets && typeof window.MPDeferredAssets.loadImage === 'function') {
        window.MPDeferredAssets.loadImage(img);
      }
    });
  }

  function setNodeVisibility(node, visible) {
    node.classList.toggle('mp-color-media-hidden', !visible);
  }

  function filterGalleryByColor(productInfo, variant) {
    if (!productInfo || !variant) return false;

    var map = readMap(productInfo);
    if (!map || !map.colorOptionKey) return false;

    var colorValue = variant[map.colorOptionKey];
    if (!colorValue) return false;

    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return false;

    var slides = gallery.querySelectorAll('.product__media-item[data-mp-color-prefix]');
    if (!slides.length) return false;

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item[data-mp-color-prefix]');
    var firstVisibleMediaId = null;
    var visibleCount = 0;

    slides.forEach(function (slide) {
      var match = prefixMatchesColor(slide.dataset.mpColorPrefix, colorValue);
      setNodeVisibility(slide, match);

      if (match) {
        visibleCount += 1;
        if (!firstVisibleMediaId) {
          firstVisibleMediaId = slide.dataset.mediaId;
        }
      }
    });

    thumbs.forEach(function (thumb) {
      var match = prefixMatchesColor(thumb.dataset.mpColorPrefix, colorValue);
      setNodeVisibility(thumb, match);
    });

    gallery.querySelectorAll('.product__media-item:not([data-mp-color-prefix])').forEach(function (slide) {
      setNodeVisibility(slide, false);
    });

    gallery.querySelectorAll('.thumbnail-list__item:not([data-mp-color-prefix])').forEach(function (thumb) {
      setNodeVisibility(thumb, false);
    });

    if (firstVisibleMediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstVisibleMediaId, false);
      loadDeferredSlideImage(gallery.querySelector('[data-media-id="' + firstVisibleMediaId + '"]'));
    }

    var totalCounter = gallery.querySelector('.slider-counter--total');
    if (totalCounter) {
      totalCounter.textContent = String(visibleCount);
    }

    var currentCounter = gallery.querySelector('.slider-counter--current');
    if (currentCounter) {
      currentCounter.textContent = visibleCount > 0 ? '1' : '0';
    }

    return true;
  }

  function bindProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.mpColorMediaBound === 'true') return;
    if (!productInfo.querySelector('[data-mp-color-media-map]')) return;

    productInfo.dataset.mpColorMediaBound = 'true';

    var attemptFilter = function (attemptsLeft) {
      if (filterGalleryByColor(productInfo, readSelectedVariant(productInfo))) return;
      if (attemptsLeft <= 0) return;
      requestAnimationFrame(function () {
        attemptFilter(attemptsLeft - 1);
      });
    };

    attemptFilter(5);
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.sectionId || !data.variant) return;

    var productInfo = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
    if (!productInfo) return;

    filterGalleryByColor(productInfo, data.variant);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('product-info').forEach(bindProductInfo);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
